(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["domivo-product-reviews"] && !Shopify.designMode) return;
  try {
    function initializeDomivoReviews(scope) {
    scope.querySelectorAll('[data-domivo-reviews]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      const list = root.querySelector('[data-review-list]');
      const filter = root.querySelector('[data-review-filter]');
      const sort = root.querySelector('[data-review-sort]');
      const more = root.querySelector('[data-review-more]');
      const status = root.querySelector('[data-review-status]');
      if (!list || !filter || !sort || !more || !status) return;
      root.dataset.initialized = 'true';
      const STEP = 5;
      const total = Number(root.dataset.total) || 0;
      let cards = Array.from(list.querySelectorAll('[data-review-card]'));
      let loaded = cards.length >= total;
      let loading = null;
      let shown = STEP;
      let matching = cards;
      /* Останалите мнения - чак когато потрябват (templates/product.reviews.liquid). */
      const ensureAll = () => {
        if (loaded) return Promise.resolve();
        if (!loading) {
          more.disabled = true;
          status.hidden = false;
          status.textContent = 'Зареждане на отзивите…';
          loading = fetch(root.dataset.src, { credentials: 'same-origin' })
            .then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); })
            .then((html) => {
              const box = document.createElement('div');
              box.innerHTML = html;
              const all = Array.from(box.querySelectorAll('[data-review-card]'));
              if (all.length) {
                list.replaceChildren(...all);
                cards = all;
              }
              loaded = true;
            })
            .catch(() => { loading = null; })
            .finally(() => { more.disabled = false; });
        }
        return loading;
      };
      const reveal = () => {
        cards.forEach((card) => { card.hidden = true; });
        matching.forEach((card, index) => { card.hidden = index >= shown; });
        more.hidden = shown >= (loaded ? matching.length : total);
        status.hidden = false;
        status.textContent = matching.length
          ? `Показани ${Math.min(shown, matching.length)} от ${loaded ? matching.length : total} отзива`
          : 'Няма отзиви с избраната оценка.';
      };
      const refresh = (keepShown) => {
        if (!keepShown) shown = STEP;
        matching = cards.filter((card) => filter.value === 'all' || Math.round(Number(card.dataset.rating)) === Number(filter.value));
        matching.sort((a, b) => {
          const dateOrder = (b.dataset.date || '').localeCompare(a.dataset.date || '');
          if (sort.value === 'highest') return Number(b.dataset.rating) - Number(a.dataset.rating) || dateOrder;
          if (sort.value === 'lowest') return Number(a.dataset.rating) - Number(b.dataset.rating) || dateOrder;
          return dateOrder;
        });
        matching.forEach((card) => list.appendChild(card));
        reveal();
      };
      more.addEventListener('click', () => {
        const previous = shown;
        ensureAll().then(() => {
          shown += STEP;
          refresh(true);
          if (matching[previous]) matching[previous].focus({ preventScroll: true });
        });
      });
      const onChange = () => ensureAll().then(() => refresh(false));
      filter.addEventListener('change', onChange);
      sort.addEventListener('change', onChange);
      root.querySelector('[data-review-controls]').hidden = false;
      refresh(false);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeDomivoReviews(document), { once: true });
  } else {
    initializeDomivoReviews(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeDomivoReviews(event.target));
  } catch(e) { console.error(e); }
})();

})();
